<template>
  <div>

    <md-table v-model="cinovi" md-sort="cin.cin_datum" md-sort-order="desc" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-sort-by="cin.cin_naslov" md-label="Naslov">{{ item.cin.cin_naslov.substring(0,36) }}<p v-if="item.cin.cin_naslov.length > 35">...</p></md-table-cell>
        <md-table-cell md-label="Način">{{ item.cin.cin_nacin_negiranja }}</md-table-cell>
        <md-table-cell md-label="Opis">{{ item.cin.cin_citat_opis.substring(0,36) }}<p v-if="item.cin.cin_citat_opis.length > 35">...</p></md-table-cell>
        <md-table-cell md-label="Link"><a :href="item.cin.cin_link">{{ item.cin.cin_link.substring(0,50) }}<p v-if="item.cin.cin_link.length > 50">...</p></a></md-table-cell>
        <md-table-cell md-label="Država">{{ item.cin.cin_drzava }}</md-table-cell>
        <md-table-cell md-label="Negator">{{ item.negator.negator_ime_naziv }}</md-table-cell>
        <md-table-cell md-label="Platforma">{{ item.platforma.platforma_naziv }}</md-table-cell>
        <md-table-cell md-sort-by="cin.cin_datum" md-label="Datum">{{ new Date(item.cin.cin_datum).toLocaleDateString("en-GB") }}</md-table-cell>
        <md-table-cell md-label="">
            <router-link :to="'/editentry/'+item.cin.uuid_cin">Izmijeniti</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>

  </div>
</template>

<script>
import axios from "axios";

let fieldsDef = [
  {
    name:"title-slot"
  },
  "cin_nacin_negiranja",
  {
    name: "cin_citat_opis",
    formatter(value) {
      return value.substring(0, 50) + "...";
    },
  }
  
];
export default {
  name: "cisti-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  methods:{
  },
  data() {
    return {
      selected: [],
      fields: fieldsDef,
      httpOptions: "",
      cinovi: []
    }
  },
  components: {
    
  },
  mounted: async function(){
      const token = await this.$auth.getTokenSilently()
       axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/cinovi",
       {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.cinovi = response.data
        })) 
  },
  updated: function()
  {
  }
};
</script>
